module.exports = __webpack_public_path__ + "static/media/videowall.489cab34.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/videowall.jpg
// module id = 283
// module chunks = 0